const rawOrigin = import.meta.env.VITE_SITE_URL as string | undefined;

export const siteOrigin = (rawOrigin || "https://usfanslink.ink").replace(/\/+$/, "");
export const siteName = "USFansLink";
export const siteLogo =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export function getSiteSchema(): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${siteOrigin}/#organization`,
        name: siteName,
        url: siteOrigin,
        logo: { "@type": "ImageObject", url: siteLogo },
      },
      {
        "@type": "WebSite",
        "@id": `${siteOrigin}/#website`,
        name: siteName,
        url: siteOrigin,
        inLanguage: ["en", "pl", "es", "fr"],
        publisher: { "@id": `${siteOrigin}/#organization` },
      },
    ],
  };
}

export interface ArticleSchemaInput {
  headline: string;
  description: string;
  image?: string;
}

export function getArticleSchema(input: ArticleSchemaInput): Record<string, unknown> {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.headline,
    description: input.description,
    datePublished: "2026-08-21",
    dateModified: "2026-08-21",
    author: {
      "@type": "Organization",
      name: siteName,
      url: siteOrigin,
    },
    publisher: {
      "@type": "Organization",
      name: siteName,
      logo: { "@type": "ImageObject", url: siteLogo },
    },
  };

  if (input.image) {
    schema.image = input.image;
  }

  return schema;
}